module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av727-a5ccae9e636d13a494aeaa3ed2dbd479.jpg";